import customDecodeURIComponent from './customDecodeURIComponent';

const getCSRFToken = () => {
  const cookies = {
    csrftoken: undefined,
  };

  if (document.cookie && document.cookie !== '') {
    document.cookie.split(';').forEach(c => {
      const m = c.trim().match(/(\w+)=(.*)/);

      if (m) {
        cookies[m[1]] = customDecodeURIComponent(m[2]);
      }
    });
  }
  return cookies.csrftoken;
};

export default getCSRFToken;
